// extracted by mini-css-extract-plugin
export default {"ZeroState":"ZeroState_ZeroState__P+uJB","Image":"ZeroState_Image__XlpYJ","Header":"ZeroState_Header__ScUth","Muted":"ZeroState_Muted__a331B"};